import { GeneralTable } from "@/shared/components/ui";
import { getPreventaByReferidoEmpleado, useGetPreventas } from "@/shared/actions/erp";
import { useCheckPermissions, useTableColumnsPreventa, useTableFilter, useTableServerSideFiltering } from "@/shared/hooks";
import { Button, Grid } from "@mui/material";
import { PermissionsEnum } from "@/auth/interfaces";
import { IDataPreventa } from "@/shared/interfaces";
import { EstadoPreventaEnum, EstadoReferidoChoiceEnum, generateUUID, TABLE_CONSTANTS } from "@/shared";
import { PiMicrosoftExcelLogoFill } from "react-icons/pi";
import { useGlobalProgressBarStore } from "@/store/ui";
import { useExcelDownloadLoaderStore, ExcelDownloadLoader } from "@/erp/inventario/kardex/componente";

interface TableReferidoComponenteProps {
  estado_referido?: EstadoReferidoChoiceEnum | null
  tipo_referido?: 'CLIENTE' | 'EMPLEADO'
  estado_preventa_exclude?: string | null
}
export default function TableReferidoComponente({
  estado_referido,
  tipo_referido = 'CLIENTE',
  estado_preventa_exclude = `${EstadoPreventaEnum.CANCELADO}`
}: TableReferidoComponenteProps) {

  useCheckPermissions(PermissionsEnum.api_view_preventa);

  //HOOK PERSONALIZADO
  const { columnsReferido } = useTableColumnsPreventa(EstadoPreventaEnum.CANCELADO);

  const {
    pagination,
    dateBefore,
    dateAfter,
    setPagination,
  } = useTableFilter();

  const initDownload = useExcelDownloadLoaderStore(s => s.initDownload)


  const { pageIndex, pageSize } = pagination;

  const { filterObject, columnFilters, setColumnFilters } =
    useTableServerSideFiltering();

  const { isLoading, data: preventasRes,
    isRefetching, } = useGetPreventas({
      //identificacion: searchTerm,
      estado_referido: estado_referido,
      tipo_referido: tipo_referido,
      page: pageIndex + 1,
      page_size: pageSize,
      fecha_preventa_before: dateBefore,
      fecha_preventa_after: dateAfter,
      estado_preventa_exclude: estado_preventa_exclude,
      ...filterObject,
      filterByState: false
    });


  return (
    <>
      <Grid container spacing={2} justifyContent="flex-end">
        {
          tipo_referido === 'EMPLEADO' && (
            <Grid item>
              <Button
                startIcon={<PiMicrosoftExcelLogoFill />}
                color="success"
                variant="contained"
                onClick={async () => {
                  initDownload('preventa/referidos-empleados/excel-async', {})
                }}
              >
                EXCEL
              </Button>
            </Grid>
          )
        }
        <Grid item xs={12}>
          <GeneralTable<IDataPreventa>
            columns={columnsReferido}
            data={preventasRes?.data.data || []}
            isLoading={isLoading}
            isRefetching={isRefetching}
            // // search
            enableGlobalFilter={false}
            // onGlobalFilterChange={setGlobalFilter}
            pagination={pagination}
            onPaging={setPagination}
            rowCount={preventasRes?.data?.count}

            ///* filters - server side
            enableManualFiltering={true}
            columnFilters={columnFilters}
            onColumnFiltersChange={setColumnFilters}
            enableSorting={false}

            // crud
            canEdit={false}
            enableEditing={false}
            showCustomActionBtnSpace={false}
            actionsColumnSize={TABLE_CONSTANTS.ACTIONCOLUMN_WIDTH_SMALL}
          />
        </Grid>
      </Grid>

      <ExcelDownloadLoader />
    </>

  );



}